<div class="image-container" >
  <img src="{{src}}" class=" circular-image " [style]="'width: ' + size + 'px; height: ' + size + 'px; '"  />
</div>
